import WebApiService from "@/services/webapi.service.js";
import Utente from "@/models/utente.model.js";
import LoginData from "@/models/loginData.model.js";

const state = {
    utente: null
}

const getters = {

    getUtente: (state) => {
        let utente = state.utente;
        if(!utente){
            utente = JSON.parse(new Buffer.from(localStorage.getItem("utente"), 'base64').toString('ascii'));
        }      
        return utente;
    },
    getInizialiUtente: (state) => {
        let utente = state.utente;
        if(!utente){
            utente = JSON.parse(new Buffer.from(localStorage.getItem("utente"), 'base64').toString('ascii'));
        }
        if(utente && utente.DettagliUtente && utente.DettagliUtente.DatiUtente){
            return utente.DettagliUtente.DatiUtente.Nome.substring(0,1) +  utente.DettagliUtente.DatiUtente.Cognome.substring(0,1) ;
        }
        return ""; 
    },
    getCompanyUtente: (state) =>{
        let utente = state.utente;
        if(!utente){
            utente = JSON.parse(new Buffer.from(localStorage.getItem("utente"), 'base64').toString('ascii'));
        }
        if(utente && utente.DettagliUtente && utente.DettagliUtente.DatiUtente){
            return utente.DettagliUtente.DatiAzienda.Codice;
        }
    }
}

const mutations = {

    setUtente: (state, utente) => {
        state.utente = utente;
        localStorage.setItem("utente", Buffer.from(JSON.stringify(utente)).toString("base64"));        
    },

    setDettagliUtente: (state, dettagliUtente) => {            
        let utente = state.utente;
        if(!utente){
            utente = JSON.parse(new Buffer.from(localStorage.getItem("utente"), 'base64').toString('ascii'));
        }      
        utente.DettagliUtente = dettagliUtente;
        state.utente = utente;
        localStorage.setItem("utente", Buffer.from(JSON.stringify(utente)).toString("base64"));     
    },
    logout: (state) => {
        state.utente = null;
        localStorage.clear();
    }
}

const actions = {

    login: ({commit}, user) => {       
        
        let loginData = new LoginData(user.username, user.password, user.idCompany, user.idPortale);
        
        return WebApiService.login('account/login', user.apikey, loginData).then(
        (data) => {              
                if(data.StatusCode !== 200){
                    return [false, data.Message];
                }
                else{
                    let utente = new Utente();
                    utente.Token = data.Data.token;
                    commit("setUtente", utente);
                    return [true, ""];            
                }
            },
            error => {                      
                return [false, ""];
            }
        )
        .catch(
            error => {return [false, ""]}
        );
    }
}

export default{
    namespeced: true,
    state,
    getters,
    mutations,
    actions
}